<template>
    <div :class="one ? 'member-information containerNew' : 'member-information'">
        <div class="common-header-wrap">
            <!-- 兌換碼列表 -->
            <mt-header :title="$t('hunt4')" class="common-header">
                <mt-button slot="left" icon="back" @click="one ? onPage(objData.page || 'index') : $router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="news">
            <div class="news_box" v-for="el in list" :key="el.id">
                <div class="news_box_le">
                    <img :src="el.image || require('../../../assets/image/one/hunt_duih.png')" alt="">
                </div>
                <div class="news_box_ri">
                    <!-- <div>{{ $t('yi18') }}{{ el.phase_sn || '' }}{{ $t('yi19') }}</div> -->
                    <div style="display: flex;"><span style="flex: 1;">{{ el.phase_sn || '' }}</span></div>
                    <div>
                        {{ $t('hunt5') }}
                        {{ el.exchange_code || '' }} 
                        <img @click="copyText(el.exchange_code)" src="../../../assets/image/one/copy.png" alt="">
                    </div>
                    <div>{{ el.is_exchange == 0 ? $t('new9') : $t('new8') }}</div>
                </div>

                <!-- <div class="news_box_win">
                    <div>{{ el.is_exchange == 0 ? $t('new9') : $t('new8') }}</div>
                </div> -->
            </div>
            <div class="more" v-if="(page * limit) < newsList.total" @click="more">{{ $t('hunt6') }}</div>
        </div>
    </div>
</template>


<script>
import { ExchangeList } from '../../../api/memberOne'
import { Toast } from 'mint-ui'
export default {
    name: 'HuntCashNew',
    data() {
        return {
            page: 1,
            limit: 10,
            id: '',
            newsList: [],
            list: []
        }
    },
    created() {
    },
    props: {
        one: {
            default: false,
            type: Boolean
        },
        objData: {
            default: () => {},
            type: Object
        },
    },
    mounted() {
        const data = this.$route.query.data;
        this.id = data

        if(this.one && this.objData && this.objData.id) {
            this.id = this.objData.id
        }

        this.getNews()
    },
    methods: {
        more() {
            this.page++
            this.getNews()
        },
        onPage(v, val) {
            this.$emit('onPage', v, val)
        },
        goNav(name = 'HuntIndex', val) {
            this.$router.push({ name: name, query: { data: val } })
        },
        onGoNav(v) {
            if (v.is_win == 1) this.goNav('HuntCash', v.exchange_code)
        },
        getNews() {
            const { page, limit, list, id } = this
            ExchangeList({
                page, limit,
                activity_id: id
            }, 'one').then(res => {
                if (res && res.result) {
                    this.newsList = res.result
                    list.push(...res.result.data)
                }
            })
        },
        copyText(v) {
            const textarea = document.createElement('textarea');
            textarea.value = v || ''
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                const successful = document.execCommand('copy');
                if(successful){
                    Toast(this.$t('copyS'))
                }else{
                    Toast(this.$t('copyE'))
                }
            } catch (err) {
                
            }
            document.body.removeChild(textarea);
        },
    }
}
</script>


<style lang="scss" scoped>
.containerNew{
    height: 100% !important;
}
.member-information {
    display: flex;
    flex-direction: column;
    height: 100vh;

    .news {
        overflow-y: auto;
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 17px 8px 20px;
        box-sizing: border-box;

        .news_box {
            width: 100%;
            display: flex;
            // border-bottom: 1px solid #CCCCCC;
            font-size: 16px;
            // padding-bottom: 15px;
            margin-bottom: 15px;
            background: #FFFFFF;
            border-radius: 6px;
            padding: 12px 14px;
            box-sizing: border-box;
            z-index: 1;

            .news_box_le {}

            img {
                width: 84px;
                height: 85px;
            }

            .news_box_ri {
                flex: 1;
                margin-left: 20px;

                div:nth-child(1) {
                    font-weight: bold;
                    color: #666;
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 10px 0;
                    border-bottom: 1px solid #DFDFDF;
                }

                div:nth-child(2) {
                    padding: 8px 0;
                    color: #333333;
                    font-size: 14px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                    line-height: 1.5;

                    img {
                        width: 15px;
                        height: 15px;
                    }
                }
                div:nth-child(3) {
                    font-size: 12px;
                    text-align: right;
                }
            }

            .news_box_win {
                padding: 10px 0;
                margin-left: 10px;
                font-size: 12px;
            }
        }
    }

    .more {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        text-align: center;
        height: 30px;
        border-radius: 20px;
        border: 1px solid #FE3421;
        font-size: 16px;
        color: #FE3421;
    }
}
</style>
